import store from '@/store';

const processing = {
    getImage(action) {
        if (action.FIELDS.DETAIL_PICTURE) {
            return action.FIELDS.DETAIL_PICTURE;
        } 
        return false;
    },

    getOgImage(action) {
        let image = this.getImage(action)

        if(image) {
            return image.SRC;
        }
        return "https://"+store.getters.getServer+"/images/logo/logo-share.jpg";
    },

    getOgImageWidth(action) {
        let image = this.getImage(action)
        if(image) {
            return ""+image.WIDTH;
        }
        return "420";
    },

    getOgImageHeight(action) {
        let image = this.getImage(action)
        if(image) {
            return ""+image.HEIGHT;
        }
        return "420";
    },
}

const templates =  {
    "shop.okraina.ru": {
        title: "ELEMENT_META_TITLE",
        tags: [
            {
                name: "description",
                content: "ELEMENT_META_DESCRIPTION",
            },
            {
                name: "keywords",
                content: "ELEMENT_META_KEYWORDS",
            },
            {
                name: "og:type",
                content: "website"
            },
            {
                name: "og:image",
                content: (action) => {
                    return processing.getOgImage(action);
                }
            },
            {
                name: "og:image:width",
                content: (action) => {
                    return processing.getOgImageWidth(action);
                }
            },
            {
                name: "og:image:height",
                content: (action) => {
                    return processing.getOgImageHeight(action);
                }
            },
            {
                name: "og:title",
                content: "ELEMENT_META_TITLE",
            },
            {
                name: "og:description",
                content: "ELEMENT_META_DESCRIPTION",
            },
        ]
    },
    "dostavka.okraina.ru": {
        title: "ELEMENT_META_TITLE",
        tags: [
            {
                name: "description",
                content: "ELEMENT_META_DESCRIPTION",
            },
            {
                name: "keywords",
                content: "ELEMENT_META_KEYWORDS",
            },
            {
                name: "og:type",
                content: "website"
            },
            {
                name: "og:image",
                content: (action) => {
                    return processing.getOgImage(action);
                }
            },
            {
                name: "og:image:width",
                content: (action) => {
                    return processing.getOgImageWidth(action);
                }
            },
            {
                name: "og:image:height",
                content: (action) => {
                    return processing.getOgImageHeight(action);
                }
            },
            {
                name: "og:title",
                content: "ELEMENT_META_TITLE",
            },
            {
                name: "og:description",
                content: "ELEMENT_META_DESCRIPTION",
            },
        ]
    },
}
export default templates;